import React, { Component } from "react"

/* REST API */
import { adminOperators } from "../api/Operator"
import { variables } from "../api/Profile"
import { catalog } from "../api/Game"

/* JWT */
import { isExpired } from "react-jwt"

/* Redux */
import { connect } from "react-redux"

/* Lottie */
import Lottie from "lottie-react"

/* Lottie File */
const LOADONG = require("../constants/mainloading.json")


/* THE STATUSES THE SERVER ANSWERS WITH WHEN IT REFUSES THE TOKEN */
const REJECTED = [401, 403, 498]


/* Component MainLoading — THE ONLY OWNER OF THE BOOT REQUESTS OF THE PANEL
 *
 * The store used to fire the very same three requests as a side effect of being imported, which meant they could
 * run twice per boot depending on how fast the network answered. Everything the panel needs before the first
 * screen is loaded here, once, on mount */
class MainLoading extends Component {

    componentDidMount = () => {
        this.load()
    }

    /* Leave For The Login Screen */
    logout = () => {
        localStorage.removeItem("token")
        this.props.setLoading(false)
        window.location.href = "/"
    }

    /* Load Action — the operators of the token, the admin behind it and the catalogue of the games */
    load = () => {

        /* Fields */
        const { token, setOperators, setAdmin, setCatalog, setLoading } = this.props

        /* Check Token — an absent or an expired one never reaches the server */
        if (!token || isExpired(token)) {
            this.logout()
            return
        }

        /* Send to REST API */
        Promise.all([adminOperators(token), variables(token), catalog()]).then(([operators, admin, games]) => {

            /* Check Token — the server has the last word on it */
            if (!operators || REJECTED.includes(operators.status)) {
                this.logout()
                return
            }

            /* Operators — every operator of the token starts checked */
            if (operators.status === 200 && Array.isArray(operators.data)) {
                setOperators(operators.data.map((operator) => ({ ...operator, checked: true })))
            }

            /* Admin */
            if (admin && admin.status === 200) {
                setAdmin(admin.data)
            }

            /* Catalogue — an empty one only means the games are drawn by their key */
            if (games && games.status === 200) {
                setCatalog({
                    types: games.data.types || [],
                    games: games.data.games || [],
                    studios: games.data.studios || [],
                    currencies: games.data.currencies || [],
                })
            }

            /* Stop Loading */
            setLoading(false)

        }).catch(() => {

            /* The network is down — the panel opens on whatever the store already holds */
            setLoading(false)
        })

    }

    render = () => {

        /* Fields */
        const { loading, children } = this.props

        /* Check Loading */
        if (loading) {
            return (
                <div className="main-loading">
                    <Lottie animationData={LOADONG} loop={true} />
                </div>
            )
        }

        /* Send Result */
        return children

    }

}


const mapStateToProps = (state) => {
    return {
        loading: state.loading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setOperators: (data) => dispatch({ type: "SET_OPERATORS", payload: data }),
        setAdmin: (data) => dispatch({ type: "SET_ADMIN", payload: data }),
        setCatalog: (data) => dispatch({ type: "SET_CATALOG", payload: data }),
        setLoading: (data) => dispatch({ type: "SET_LOADING", payload: data }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainLoading)
